import { FC, ReactNode } from "react"
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome"
import { faCircleInfo } from "@fortawesome/pro-regular-svg-icons"
import styles from "./iwpCardsStyles.module.scss"
import ToolTip from "../../shared/toolTip/tooltip"

interface CardProps {
    title: string
    value: number | string | undefined
    tooltip?: string
    className?: string
}

export const StatsCard: FC<CardProps> = ({ title, value, tooltip }) => {
    return (
        <div className={styles.iwpCard}>
            <h3>
                <span className={styles.iwpCardMarginRight4}> {title}</span>
                {tooltip && (
                    <>
                        <ToolTip
                            tooltipContent={<div>{tooltip}</div>}
                            triggerChildren={
                                <span className={styles.infoIcon}>
                                    <FontAwesomeIcon
                                        color="#0398FC"
                                        icon={faCircleInfo}
                                    />
                                </span>
                            }
                        />
                    </>
                )}
            </h3>
            <p>{value}</p>
        </div>
    )
}

interface CardContainerProps {
    children: ReactNode
}

export const StatsCardContainer: FC<CardContainerProps> = ({ children }) => {
    return <div className={styles.iwpCardContainer}>{children}</div>
}
